import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { useIntl } from 'ha/i18n';
import { Link } from '@hbf/dsl';
import { User } from '@ha/api/v2/types/User';
import { SmartTrack as Track } from 'ha/components/track/SmartTrack';

const useStyles = makeStyles()(() => ({
  link: {
    textDecoration: 'none',
  },
}));

interface Props {
  user: User;
  dataTestLocator?: string;
}

const UserCardLink: React.FC<Props> = ({ children, user, dataTestLocator }) => {
  const { urlResolver } = useIntl();
  const { classes } = useStyles();

  return (
    <Track name="Clicked Advertiser name" type="link">
      <Link
        to={urlResolver.getLinkToUserPage(user.id)}
        target="_blank"
        className={classes.link}
        title="Profile preview"
        data-test-locator={dataTestLocator}
      >
        {children}
      </Link>
    </Track>
  );
};

export { UserCardLink };
